// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"ResetPassword_wrapperComponent__JvB4P","form":"ResetPassword_form__Z43m-","actions":"ResetPassword_actions__nKPiz"};